export const SENDING_REQUEST = 'CLASSIFIERGROUPSLIST_SENDING_REQUEST';
export const GETALL_SUCCESS = 'CLASSIFIERGROUPSLIST_GETALL_SUCCESS';
export const GETALL_FAILURE = 'CLASSIFIERGROUPSLIST_GETALL_FAILURE';